import { useState, useEffect } from "react";
import { Rocket } from "lucide-react";

const ukLocations = [
  "London", "Manchester", "Birmingham", "Leeds", "Bristol", "Liverpool",
  "Sheffield", "Newcastle", "Nottingham", "Southampton", "Edinburgh",
  "Glasgow", "Cardiff", "Belfast", "Brighton", "Oxford", "Cambridge",
  "Bath", "York", "Chester", "Exeter", "Norwich", "Reading", "Leicester",
  "Coventry", "Derby", "Plymouth", "Swansea", "Aberdeen", "Dundee",
  "Bournemouth", "Cheltenham", "Canterbury", "Winchester", "Guildford",
  "St Albans", "Harrogate", "Stratford-upon-Avon", "Tunbridge Wells",
  "Henley-on-Thames", "Richmond", "Epsom", "Woking", "Maidenhead",
  "Solihull", "Wilmslow", "Altrincham", "Hale", "Knutsford", "Formby",
];

const generateDeal = () => {
  const location = ukLocations[Math.floor(Math.random() * ukLocations.length)];
  const agentNum = Math.floor(Math.random() * (9986 - 27 + 1)) + 27;
  const raw = Math.pow(Math.random(), 2);
  const amount = Math.floor(raw * (12870 - 1005 + 1)) + 1005;
  const formattedAmount = `£${amount.toLocaleString("en-GB")}`;
  const formattedAgent = String(agentNum).padStart(5, "0");
  return { location, agent: formattedAgent, amount: formattedAmount };
};

export const SocialProofTicker = () => {
  const [deal, setDeal] = useState(generateDeal);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setDeal(generateDeal());
        setFading(false);
      }, 400);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex justify-start">
      <div
        className={`inline-flex items-center gap-3 bg-card border border-border rounded-full px-5 py-2.5 shadow-[var(--shadow-subtle)] transition-opacity duration-400 ${
          fading ? "opacity-0" : "opacity-100"
        }`}
      >
        <div className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
          <Rocket className="h-4 w-4" />
        </div>
        <p className="text-sm font-bold text-foreground">
          Agent #{deal.agent} just sold a deal in{" "}
          <span className="text-primary">{deal.location}</span> for{" "}
          <span className="text-primary">{deal.amount}</span>
        </p>
      </div>
    </div>
  );
};
